/**
 * CustomScrollbar — 24px-wide custom scrollbar UI.
 *
 * Renders the bar DOM only. Behavior is wired by
 * services/scrollbar.js#attachScrollbar.
 *
 * Layout (top → bottom):
 *   1. ws-scroll-btn-top      double-chevron up   (jump to top)
 *   2. ws-scroll-btn-up       single-chevron up   (hold to scroll up)
 *   3. ws-scroll-track        →  ws-scroll-thumb (draggable)
 *   4. ws-scroll-btn-down     single-chevron down (hold to scroll down)
 *   5. ws-scroll-btn-bottom   double-chevron down (jump to bottom)
 *
 * Returns:
 *   { root, refs: { scrollbar, track, thumb, btnTop, btnUp, btnDown, btnBottom } }
 *
 * Variant override:
 *   Replace via registry.registerComponent('CustomScrollbar', MyBar)
 *   if you need a fundamentally different control set. For just
 *   color/size tweaks, override the --ws-scrollbar-* CSS vars.
 */

const SVG_DOUBLE_UP = `<svg viewBox="0 0 7 8" width="7" height="8" fill="none" aria-hidden="true"><path d="M6.33 3.42 3.42 0.5.5 3.42M6.33 7.5 3.42 4.58.5 7.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const SVG_UP = `<svg viewBox="0 0 8 5" width="8" height="5" fill="none" aria-hidden="true"><path d="M7.5 4 4 0.5.5 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const SVG_DOWN = `<svg viewBox="0 0 8 5" width="8" height="5" fill="none" aria-hidden="true"><path d="M.5 0.5 4 4l3.5-3.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const SVG_DOUBLE_DOWN = `<svg viewBox="0 0 7 8" width="7" height="8" fill="none" aria-hidden="true"><path d="M.5 0.5 3.42 3.42 6.33 0.5M.5 4.58 3.42 7.5 6.33 4.58" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const SVG_GRIP = `<svg viewBox="0 0 9 2" width="9" height="2" fill="none" aria-hidden="true"><rect x="9" width="2" height="9" rx="1" transform="rotate(90 9 0)" fill="currentColor"/></svg>`;

function makeBtn(cls, svg, label) {
  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = `ws-scroll-btn ${cls}`;
  btn.setAttribute("aria-label", label);
  btn.innerHTML = svg;
  return btn;
}

export default class CustomScrollbar {
  render() {
    const scrollbar = document.createElement("div");
    scrollbar.className = "ws-scrollbar";

    const btnTop = makeBtn("ws-scroll-btn-top ws-scroll-btn-jump", SVG_DOUBLE_UP, "Scroll to top");
    const btnUp = makeBtn("ws-scroll-btn-up ws-scroll-btn-step", SVG_UP, "Scroll up");
    const btnDown = makeBtn("ws-scroll-btn-down ws-scroll-btn-step", SVG_DOWN, "Scroll down");
    const btnBottom = makeBtn("ws-scroll-btn-bottom ws-scroll-btn-jump", SVG_DOUBLE_DOWN, "Scroll to bottom");

    const track = document.createElement("div");
    track.className = "ws-scroll-track";

    const thumb = document.createElement("div");
    thumb.className = "ws-scroll-thumb";
    thumb.innerHTML = `${SVG_GRIP}${SVG_GRIP}${SVG_GRIP}`;
    track.appendChild(thumb);

    scrollbar.appendChild(btnTop);
    scrollbar.appendChild(btnUp);
    scrollbar.appendChild(track);
    scrollbar.appendChild(btnDown);
    scrollbar.appendChild(btnBottom);

    return {
      root: scrollbar,
      refs: { scrollbar, track, thumb, btnTop, btnUp, btnDown, btnBottom },
    };
  }
}
